__turbopack_context__.v({
  "bottomSide": "TooltipMenu-module-scss-module__hHX4hG__bottomSide",
  "close": "TooltipMenu-module-scss-module__hHX4hG__close",
  "leftSide": "TooltipMenu-module-scss-module__hHX4hG__leftSide",
  "rightSide": "TooltipMenu-module-scss-module__hHX4hG__rightSide",
  "tooltipMenu": "TooltipMenu-module-scss-module__hHX4hG__tooltipMenu",
  "topSide": "TooltipMenu-module-scss-module__hHX4hG__topSide",
  "visible": "TooltipMenu-module-scss-module__hHX4hG__visible",
});
